<template>
    <div class="app-container">
        <div class="handleExport-zy">投诉分派</div>
        <!-- 操作按钮 -->
      <div class="demo-row">
        <el-row  :gutter="10" class="mb15">
          <el-col :style="{ fontSize: '14px' }">已选择 {{numberS}} 项</el-col>
        </el-row>
        <el-row :gutter="10" class="mb15">
          <el-col :span="1.5">
            <el-button plain
                       @click="handleDelete(10)">取消选择</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary"  @click="handleClear(10)">批量分派</el-button>
          </el-col>

        </el-row>
      </div>

        <!-- 表格展示 -->
        <el-table border :data="logList" @selection-change="handleSelectionChange" v-loading="loading">
            <!-- 表格列 -->
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <!--投诉编号 -->
            <el-table-column label="投诉编号" width="160" align="center" prop="taskName"
                :show-overflow-tooltip="true"></el-table-column>
            <!--项目名称 -->
            <el-table-column label="项目名称" width="140" align="center" prop="taskGroup"></el-table-column>
            <!-- 投诉人 -->
            <el-table-column label="投诉人" width="150" align="center" prop="invokeTarget"
                :show-overflow-tooltip="true"></el-table-column>
            <!-- 欠薪金额(元) -->
            <el-table-column label="欠薪金额(元)" align="center" prop="taskMessage"
                :show-overflow-tooltip="true"></el-table-column>
            <!-- 项目金额(万元)-->
            <el-table-column label="项目金额(万元)" align="center" prop="taskMessage"
                           :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <pagination v-if="count > 0" :total="count" :page.sync="queryParams.current" :limit.sync="queryParams.size"
            />
        </div>

       <!--分派提示-->
        <div class="info-text">
          <el-alert
              title="分派提示"
              type="info"
              :closable="false"
              description="系统检测到您选择的投诉中，1条项目金额≥100万，应分派至区建管委+行业主管部门； 1条项目金额<100万，应分派至街镇/园区。"
              show-icon>
          </el-alert>
        </div>

        <!--分派至 、 分派说明-->
        <div class="labelFixe">
          <el-form :label-position="labelPosition" :model="assignParams" :inline="true"  >
            <el-form-item label="分派至" style="width:45%">
              <el-select v-model="assignParams.region" placeholder="请选择分派目标"  style="width:50%">
                <el-option label="交通委" value="0"></el-option>
                <el-option label="水务局" value="1"></el-option>
                <el-option label="住建委" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分派说明" style="width:45%">
              <el-input type="textarea" v-model="assignParams.region"  placeholder="请输入分派说明" style="height: 100px;"></el-input>
            </el-form-item>
          </el-form>
          <div style="float:right">
            <el-row :gutter="10" class="mb15">
              <el-col :span="1.5">
                <el-button plain
                           @click="handleDelete(undefined)"> 取消 </el-button>
              </el-col>
              <el-col :span="1.5">
                <el-button type="primary"  @click="handleClear(10)"> 确认分派 </el-button>
              </el-col>
            
            </el-row>
          </div>
        </div>
    </div>
</template>

<script>
// import {clearTaskLog, deleteException, deleteTaskLog, getTaskLogList} from '@/api/log';
// import { formatDateTime } from "@/utils/date";
// import { messageConfirm, notifySuccess } from '@/utils/modal';

export default {
  name: 'ComplaintTask',
  data() {
    return {
      count: 0,
      showSearch: true,
      loading: false,
      labelPosition: 'top',
      queryParams: {
        current: 1,
        size: 10,
      },
      logIdList: [],
      logList: [],
      assignParams: {
        region: '',
      },
      numberS: 15,
    }
  },
  methods: {
    handleSelectionChange(selection) {
      this.logIdList = selection.map((item) => item.id);
    },
    
    handleDelete() {
      // let ids = [];
      // if (id == undefined) {
      //   ids = this.logIdList;
      // } else {
      //   ids = [id];
      // }
    },

    handleClear() {
      // clearTaskLog().then(({ data }) => {
      //     if (data.flag) {
      //         notifySuccess(data.msg);
      //       //  getList();
      //     }
      // })
      // messageConfirm("确认指分派").then(() => {
      //   deleteTaskLog(ids).then(({ data }) => {
      //     if (data.flag) {
      //       notifySuccess(data.msg);
      //       //getList();
      //     }
      //   });
      // }).catch(() => { });
    }
    
    // getList() {
    //     this.loading = true;
    //     getTaskLogList(this.queryParams).then(({ data }) => {
    //         this.logList = data.data.recordList;
    //         this.count = data.data.count;
    //         this.loading = false;
    //     });
    // },
    // handleQuery() {
    //     this.queryParams.current = 1;
    //     this.getList();
    // }
  }
  // mounted() {
  //     this.getList();
  // }
}
</script>

<style scoped>
.handleExport-zy{
  margin-bottom: 30px;
}
.demo-row{
  display: flex;
  justify-content: space-between;
}
.info-text{
  margin: 30px auto;
}

::v-deep .is-light{
  background: rgb(239 246 255 / var(--tw-bg-opacity, 1));
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

::v-deep .el-alert__description{
  color: rgb(29 78 216 / var(--tw-text-opacity, 1)) !important;
}

/* 分页样式 */
.pagination-wrapper {
  margin-top: 20px;
}
</style>
